export default __webpack_public_path__ + "static/Artificial_Light_Outdoor_320kbps-65df7e17f871f85ef285a03ecd866448.avif";